import { render, staticRenderFns } from "./UploadImg.vue?vue&type=template&id=4ec4a685&scoped=true&"
import script from "./UploadImg.vue?vue&type=script&lang=js&"
export * from "./UploadImg.vue?vue&type=script&lang=js&"
import style0 from "./UploadImg.vue?vue&type=style&index=0&id=4ec4a685&scoped=true&lang=scss&"
import style1 from "./UploadImg.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec4a685",
  null
  
)

export default component.exports